import { pushDataLayer } from '@/utils';
import Vue from 'vue';

export default {
  state: {
    companies: [],
    companyIdx: 0,
    companyTemp: {},
    companyRegStep: 1,
  },
  mutations: {
    setCompanies(state, payload) {
      state.companies = payload;
    },
    setCompanyIdx(state, payload) {
      state.companyIdx = payload;
    },
    setCompanyTemp(state, payload) {
      state.companyTemp = payload;
    },
    clearCompanyTemp(state) {
      state.companyTemp = {};
    },
    setCompanyRegStep(state, payload) {
      state.companyRegStep = payload;
    },
  },
  actions: {
    async getCompanyInfo({ commit, rootState }, payload) {
      commit('clearError');
      if (!((rootState.user || {}).email || (payload || {}).email)) {
        return null;
      }
      try {
        let data = await Vue.axios.get('/company3/v2?orderBy=id&direction=desc').then(res => {
          return res.data;
        });

        commit('clearCompanyTemp');
        let companies = data.data.companies.filter(company => {
          company.id *= 1;
          if (company.is_verified === 99) {
            // 제품(PRODUCT) 타입만 임시저장 이어서 등록 지원
            // 매장(STORE) 타입은 임시저장 기능 제거됨 - 항상 최종 제출(is_verified: 3)
            if (company.category?.firstName === '제품') {
              commit('setCompanyTemp', company);
            }
            return false;
          } else {
            return true;
          }
        });
        companies = Vue._.sortBy(companies, [
          function (com) {
            return ((com.naver || {}).available || 0.1) + ((com.insta || {}).available || 0.1);
          },
        ]);

        commit('setCompanies', companies || []);

        let targetCompany = {};

        if (rootState.company.companyIdx >= companies.length || rootState.company.companyIdx === undefined) {
          commit('setCompanyIdx', 0);

          pushDataLayer({
            event: 'mixpanelRegisterAd',
          });

          targetCompany = companies[payload] || {};
        } else {
          targetCompany = companies[rootState.company.companyIdx] || {};
        }

        const properties = {
          adId: targetCompany.id,
          adName: targetCompany.name,
          adType: targetCompany.type,
          adCategory: targetCompany.category?.first,
          midCategory: targetCompany.category?.second,
          bottomCategory: targetCompany.category?.third,
          regionCompany: targetCompany.localCode_region,
          localCompany: targetCompany.localCode_local,
        };

        pushDataLayer({
          event: 'mixpanelRegisterAd',
          ...properties,
        });

        return payload;
      } catch (error) {
        console.log(error);
        alert(error.message);
      }
    },
    async signCompanyUp({ commit, rootState, dispatch }, payload) {
      commit('clearError');
      try {
        await Vue.axios.post('/company3', payload);
        dispatch('getCompanyInfo', payload);
        // commit('setCompanyIdx', rootState.companies.length - 1)

        Vue.axios.post('/utils/sendmail', {
          from: '슈퍼멤버스 <cs@supermembers.co.kr>',
          to: (rootState.user || {}).email || payload.email,
          subject: '슈퍼멤버스에 오신 것을 환영합니다.',
          template: 'companyWelcome',
          username: payload.name,
        });
        return payload;
      } catch (error) {
        console.log(error);
        alert(error.message);
      }
    },
  },
  getters: {
    company(state) {
      return state.companies[state.companyIdx || 0];
    },
    companies(state) {
      return state.companies;
    },
    companyIdx(state) {
      return state.companyIdx;
    },
    companyTemp(state) {
      return state.companyTemp;
    },
    companyRegStep(state) {
      return state.companyRegStep;
    },
  },
};
